export default __webpack_public_path__ + "static/media/Exterior-(16).776696bc.jpg";